import { fmtDate } from "@/lib/format";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const posterUrl = (s) => `${BACKEND}/api/public/seminars/${s.id}/poster${s.poster_version || s.poster?.uploaded_at ? `?v=${encodeURIComponent(s.poster_version || s.poster?.uploaded_at)}` : ""}`;

export function seminarWhen(s) {
  if (!s?.date_from) return "Data da definire";
  let out = fmtDate(s.date_from);
  if (s.date_to && s.date_to !== s.date_from) out = `Dal ${fmtDate(s.date_from)} al ${fmtDate(s.date_to)}`;
  if (s.start_time) out += ` · dalle ${s.start_time}${s.end_time ? ` alle ${s.end_time}` : ""}`;
  return out;
}

export const priceLabel = (p) => (p ? `€ ${Number(p).toFixed(2)} a persona` : "Gratuito");

export const BOOKING_STATUS = {
  nuova:      { label: "Nuova",      cls: "bg-sky-50 text-sky-800 border-sky-200" },
  confermata: { label: "Confermata", cls: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  pagata:     { label: "Pagata",     cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  annullata:  { label: "Annullata",  cls: "bg-stone-100 text-stone-500 border-stone-200" },
};
